// DeliverySection.jsx
import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import { HiOutlineChatBubbleBottomCenterText } from "react-icons/hi2";
import { BsChatDots } from "react-icons/bs";
import CustomPopupForm from "../../../../component/customPopupModel";
import { useSnackbar } from "../../../../component/SnackbarContext";
import axiosInstance from "../../../../configuration/request";
import ChatWithDelivery from "./chatWithDelivery";

const formatDate = (isoOrDateStr) => {
  if (!isoOrDateStr) return "-";
  try {
    const d = new Date(isoOrDateStr);
    // e.g. 22 Aug 2025
    return d.toLocaleDateString(undefined, {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return isoOrDateStr;
  }
};

const formatTimeSlot = (slot) => {
  if (!slot) return "-";
  const { open, close } = slot || {};
  if (open && close) return `${open} - ${close}`;
  return open || close || "-";
};
const DIALOG_TYPES = {
  CREATE: "review",
};

export default function DeliverySection({ pickupDetail, onReviewSubmit, orderId }) {
  const pickupTime = formatTimeSlot(pickupDetail?.pickup_time_slot);
  const pickupDate = formatDate(pickupDetail?.pickup_date);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const showSnackbar = useSnackbar();
  const [deliveryChat, setDeliveryChat] = useState(false);
  const hasFeedback =
    pickupDetail?.feedbacks?.score &&
    pickupDetail?.feedbacks?.content;

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogType("");
  };

  const handleAddReview = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleSubmit = (ratings) => {

    const payload = {
      score: ratings.rating,
      content: ratings.feedback,
      pickup_id: pickupDetail?.id,
      order_id: orderId,
      // maskedName: true,
      inAppropriate: false
    };
    axiosInstance
      .post(`/customer/delivery-person/feedback/create/${pickupDetail?.deliveryPerson?.id}`, payload)
      .then(() => {
        handleCloseDialog();
        onReviewSubmit();
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <div className="bg-white border border-[#D8DAE5] rounded-xl p-4 w-full mt-4">
      <div className="flex flex-col md:flex-col md:justify-start md:gap-6 xlg:flex-row xlg:justify-between">
        {/* Left */}
        <div className="flex-1">
          <div className="text-[#063853] font-semibold mb-1">
            {pickupDetail?.deliveryPerson?.name} {pickupDetail?.pickup_type === "Store_Pickup" ? "Delivery Person" : "Pickup Person"}

          </div>

          <div className="flex gap-2 mt-2">
            <div className="text-base text-[#606060]">Pickup Time</div>
            <div className="text-base text-[#000] font-[600]">{pickupTime}</div>
          </div>

          <div className="flex gap-2 mt-2">
            <div className="text-base text-[#606060]">Pickup Date</div>
            <div className="text-base text-[#000] font-[600]">{pickupDate}</div>
          </div>

          <div className="mt-2">
            <CustomButton
              onClick={() => setDeliveryChat(true)}
              // Button is disabled if pickupDetail, deliveryPerson, or name is missing
              disabled={!pickupDetail?.deliveryPerson?.user?.name}
              customeClass={`h-[35px] w-[180px] ${!pickupDetail?.deliveryPerson?.user?.name
                  ? "opacity-40 cursor-not-allowed bg-gray-400 customer-outline-button" // Styles for disabled state
                  : "customer-dark-button"
                }`}
            >
              <BsChatDots className="text-lg font-bold mr-1" />
              Chat with Driver
            </CustomButton>
          </div>

        </div>

        {/* Divider */}
        <div className="hidden xlg:block h-28 border border-dotted border-[#D2D2D2]" />
        <div className="block xlg:hidden border-t border-dotted my-3 border-[#D2D2D2] w-full" />

        {/* Right */}
        <div className="flex-1">
          <div className="text-[#063853] font-semibold mb-2">Rate Driver</div>
          <div className="flex items-center gap-4">
            <div className="flex text-gray-300 text-xl">
              {[1, 2, 3, 4, 5].map((i) => (
                <FaStar key={`driver-${i}`} />
              ))}
            </div>
            <CustomButton
              onClick={handleAddReview}
              disabled={!pickupDetail?.deliveryPerson?.user?.name}
              customeClass={`h-[35px] w-[180px] ${!pickupDetail?.deliveryPerson?.user?.name
                  ? "opacity-40 cursor-not-allowed bg-gray-400 customer-outline-button" // Styles for disabled state
                  : "customer-outline-button"
                }`}
            >
              <HiOutlineChatBubbleBottomCenterText className="mr-2 text-lg" />
              {hasFeedback ? "View Review" : "Write Review"}
            </CustomButton>
          </div>
        </div>
      </div>

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={pickupDetail?.feedbacks[0]}
          onSubmit={handleSubmit}
        />
      )}

      {deliveryChat && (
        <div className="fixed bottom-4 right-4 w-[90%] max-w-sm z-50">
          <ChatWithDelivery
            onClose={() => setDeliveryChat(false)}
            pickupId={pickupDetail?.id}

          />
        </div>
      )}
    </div>
  );
}
